import React, { useEffect, useState } from 'react'
import Content from 'blocks.app/content/content'
import CustomList from 'blocks.app/customList/customList'
import Link from 'blocks.simple/link/link'
import translate from 'core/translate'
import styles from './instancesCatalog_samsonite.jcss'
import { Steps } from 'atoms/Steps/Steps-view'
import { useLocation } from 'react-router'
import { getURLSearchParamsByLocation, getURLSearchParamsString } from 'features/routes/utils'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { SAMSONITE_CATALOG_TITLE_KEY, SamsoniteSelectedItems } from './InstancesCatalogSamsonite-types'

const categories = ['sites', 'videos', 'advertising'] as const

const InstancesCatalogSamsoniteComponent = () => {
    const location = useLocation()
    const category = categories.find((item) => item === getURLSearchParamsByLocation(location).category) || 'sites'
    const [selectedItems, setSelectedItems] = useState<SamsoniteSelectedItems>([])

    useEffect(() => {
        setSelectedItems([])
    }, [category])

    return (
        <Content title={SAMSONITE_CATALOG_TITLE_KEY}>
            <div className={styles.wrapper}>
                <Steps className={styles.tabs} active={category}>
                    {categories.map((item) => (
                        <Link
                            id={item}
                            key={item}
                            to={{
                                pathname: location.pathname,
                                search: getURLSearchParamsString({ category: item }),
                            }}
                        >
                            {translate(item)}
                        </Link>
                    ))}
                </Steps>
                <CustomList
                    key={category}
                    type={`samsonite${category[0].toUpperCase()}${category.slice(1)}`}
                    onSelect={setSelectedItems}
                    selectedItems={selectedItems}
                    isDelayTime
                    additionalData={{}}
                />
            </div>
        </Content>
    )
}

export const InstancesCatalogSamsonite = checkAvailableModule('instancesCatalog/samsonite')
    ? InstancesCatalogSamsoniteComponent
    : null
